export * from './ProductsListItemTags.types';
export { default as ProductsListItemTags } from './ProductsListItemTags';
